import {
  Box,
  Center,
  Divider,
  Spinner,
  Text as ChakraText,
} from '@chakra-ui/react'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  CacheHitRatio,
  TopTransformations,
  TopUsage,
  Usage,
} from '../../components/Analytics'
import TotalStats from '../../components/Analytics/TotalStats'
import type { AnalyticsAPIResponse } from '../../interfaces'
import { UserContext } from '../../providers'
interface Props {
  dateRange: {
    startDate: Date
    endDate: Date
  }
  data: AnalyticsAPIResponse | null
  showBandwidth: Boolean
}

const UsageAnalyticsLayout = ({
  dateRange,
  data,
  showBandwidth,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const { user } = useContext(UserContext)

  const [bandwidthGraphData, setBandwidthGraphData] = useState(null)

  const isUserOnImagekitCDN = user?.clientIsOnImageKitCDN

  if (!data) {
    return (
      <Center height="100%">
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="appPaleGrey"
          color="appBlue"
          size="xl"
        />
      </Center>
    )
  }

  return (
    <Box padding="1.5rem" marginBottom="2.5rem">
      <TotalStats {...{ data }} />
      <Usage
        {...{
          data,
          bandwidthGraphData,
          setBandwidthGraphData,
          dateRange,
        }}
      />
      {isUserOnImagekitCDN && (
        <Box marginTop="2.5rem">
          <ChakraText
            fontWeight="semibold"
            marginBottom="0.75rem"
            fontSize="16px"
          >
            {t('cache_hit_statistics', 'Cache hit statistics')}
          </ChakraText>
          <Divider />
          <CacheHitRatio {...{ data }} />
        </Box>
      )}
      {isUserOnImagekitCDN && <TopUsage {...{ data, showBandwidth }} />}
      {isUserOnImagekitCDN && (
        <Box marginTop="2.5rem">
          <ChakraText
            fontWeight="semibold"
            marginBottom="0.75rem"
            fontSize="16px"
          >
            {t('top_image_transformations', 'Top image transformations')}
          </ChakraText>
          <Divider />
          <TopTransformations {...{ data, showBandwidth, assetClass: "image" }} />
        </Box>
      )}

      {isUserOnImagekitCDN && (
        <Box marginTop="2.5rem">
          <ChakraText
            fontWeight="semibold"
            marginBottom="0.75rem"
            fontSize="16px"
          >
            {t('top_video_transformations', 'Top video transformations')}
          </ChakraText>
          <Divider />
          <TopTransformations {...{ data, showBandwidth, assetClass: "video" }} />
        </Box>
      )}
    </Box>
  )
}

export default UsageAnalyticsLayout
